import { messageFromBlob } from "../utilities/bigintFromblob";
import { GameState } from "./game-state";

export const messageTypes = {
  multiPlayerUpdate: 0,
  multiObjectUpdate: 1,
  fullMapPlayerState: 3,
};

export const getHandler = (gameState: GameState) => async (data: Blob) => {
  const message = await messageFromBlob(data);
  console.log("message", message.type);
  switch (message.type) {
    case messageTypes.fullMapPlayerState: {
      gameState.fullSync(message.data);
      break;
    }
    case messageTypes.multiPlayerUpdate: {
      gameState.bulkSyncState(message.data);
      break;
    }
    default:
      break;
  }
};
